module.exports = __webpack_public_path__ + "img/caprimo.f4e673d3.png";